var fullAddressFilter = function(CommonHelpers) {
  return function(retailerOrDistributor) {
    return CommonHelpers.addressString(retailerOrDistributor);
  };
};

fullAddressFilter.$inject = ['CommonHelpers'];

tiz.filter('fullAddress', fullAddressFilter);
